import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error",
  "use": "icon-error-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-error\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 128l128 128-256 256 256 256-128 128-256-256-256 256-128-128 256-256-256-256 128-128 256 256 256-256z\" fill=\"#d81e06\" p-id=\"4998\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol